import { Rule } from 'antd/es/form';
import { AppFormItemProps, AppFormRangeItem, AppTimePicker } from 'components/atoms';
import { formFields } from 'consts/form/formFields';
import { TIME_LABEL } from 'consts/labels/common';
import { formElementRequiredText } from 'consts/errors/forms';
import { childrenTexts } from 'consts/text';
import { AppFormRangeItemMode } from 'types';
import { datesTimelineValidator } from 'utils/validators';

export type DeclaredStayHoursTimePickerProps = AppFormItemProps & {
    mode: AppFormRangeItemMode;
};

export const DeclaredStayHoursTimePicker = ({
    mode,
    ...props
}: DeclaredStayHoursTimePickerProps) => {
    const rules: Rule[] = [
        { required: true, message: formElementRequiredText },
        ({ getFieldValue }) =>
            datesTimelineValidator(getFieldValue, {
                mode,
                startValueFieldName: formFields.declaredStayHoursFromTime,
                finishValueFieldName: formFields.declaredStayHoursToTime,
                isFinishValueBeforeStartValueErrorText:
                    childrenTexts.childForm.settlementData.declaredStayHoursEndBeforeStart,
                isStartValueAfterFinishValueErrorText:
                    childrenTexts.childForm.settlementData.declaredStayHoursStartAfterEnd,
                unitToCompare: 'minute',
            }),
    ];

    return (
        <AppFormRangeItem
            mode={mode}
            startValues={{
                label: childrenTexts.childForm.settlementData.declaredStayHoursStart,
                additionalText: TIME_LABEL,
                name: formFields.declaredStayHoursFromTime,
                rules,
                accessibilityLabel: 'Pole godzina rozpoczęcia pobytu',
            }}
            finishValues={{
                label: childrenTexts.childForm.settlementData.declaredStayHoursEnd,
                additionalText: TIME_LABEL,
                name: formFields.declaredStayHoursToTime,
                rules,
                accessibilityLabel: 'Pole godzina zakończenia pobytu',
            }}
            {...props}
        >
            <AppTimePicker
                autoComplete="off"
                accessibilityLabel="Pole godzina"
                placeholder="Wybierz godzinę"
            />
        </AppFormRangeItem>
    );
};
